import { OVMAutocomplete } from '../../models';
import {
  useAutocompleteSource,
  ApiFilterOperation,
  abortableFetch,
} from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useOVMAutocomplete(serviceId?: string) {
  const params = serviceId
    ? {
        filters: [
          {
            operation: ApiFilterOperation.EQ,
            field: 'services.id',
            value: serviceId,
          },
        ],
      }
    : {};

  return useAutocompleteSource<OVMAutocomplete>({
    url: EvidenceAPI.OVM + '/autocomplete',
    params,
  });
}

export function getOVMbyServiceId(serviceId: string) {
  return abortableFetch(`${EvidenceAPI.OVM}/autocomplete`, {
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    method: 'POST',
    body: JSON.stringify({
      filters: [
        {
          operation: ApiFilterOperation.EQ,
          field: 'services.id',
          value: serviceId,
        },
      ],
      size: 2,
    }),
  });
}

export function getOVMById(id: string) {
  return abortableFetch(`${EvidenceAPI.OVM}/${id}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    method: 'GET',
  });
}
